module.exports = __webpack_public_path__ + "img/MaskGroup 2886.a3a07b54.svg";